import React from 'react';


export function StatsItem({ children, blockName = 'stats', modifier, }) {
  const blockElement = blockName + '__item';
  const blockElementModifier = modifier ? `${ blockElement }--${ modifier }` : '';
  return (
    <li className={`${ blockElement } ${ blockElementModifier }`}>
      { children }
    </li>
  );
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/post_metadata/components/StatsItem.js